








import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getMyLeavesApi, cancelLeaveApi } from "../../app/api";
import { toast } from "react-toastify";
import {
  CalendarDays,
  Clock,
  XCircle,
  CheckCircle2,
  AlertCircle,
  Undo2,
  PieChart,
  LayoutGrid,
  Info,
  MessageSquare
} from "lucide-react";
 
function CancelModal({ show, onConfirm, onClose }) {
  if (!show) return null;
 
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={onClose} />
      <div className="
        relative w-full max-w-sm
        bg-[#12082F]
        rounded-[40px] p-8 text-center
        border border-white/20 shadow-2xl animate-scaleIn
      ">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-[28px] bg-red-500/20 flex items-center justify-center shadow-inner">
            <XCircle className="w-10 h-10 text-red-400" />
          </div>
        </div>
        <h3 className="text-2xl font-black mb-3 text-white">Cancel Leave?</h3>
        <p className="text-white/50 text-sm mb-8 leading-relaxed font-medium">
          This action cannot be undone. Are you sure you want to cancel this request?
        </p>
        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 py-3.5 rounded-2xl font-bold bg-white/5 border border-white/10 hover:bg-white/10 transition"
          >
            Go Back
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-3.5 rounded-2xl font-bold bg-red-600 text-white hover:bg-red-700 transition shadow-lg shadow-red-900/40"
          >
            Yes, Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
 
export default function MyLeaves() {
  const [searchParams] = useSearchParams();
  const selectedType = searchParams.get("type");
  const [balances, setBalances] = useState([]);
  const [leaves, setLeaves] = useState([]);
  const [modal, setModal] = useState({ show: false, leaveId: null });
 
  useEffect(() => {
    loadLeaves();

    window.addEventListener("leave-updated", loadLeaves);
    return () => {
      window.removeEventListener("leave-updated", loadLeaves);
    };
  }, []);
 
  const loadLeaves = async () => {
    const res = await getMyLeavesApi();
    if (res?.success) {
      setLeaves(res.data?.leaves || []);
      setBalances(res.data?.balances || []);
    }
  };

  const filteredLeaves = selectedType
    ? leaves.filter((leave) => {
        const typeNormalized = leave.leave_type === "Unpaid Leave" ? "Leave Without Pay [LWP]" : leave.leave_type;
        return typeNormalized === selectedType;
      })
    : leaves;
 
  const confirmCancel = async () => {
    const id = modal.leaveId;
    setModal({ show: false, leaveId: null });
    const res = await cancelLeaveApi(id);
    if (res.success) {
      toast.success("Leave cancelled successfully");
      loadLeaves();
      window.dispatchEvent(new Event("leave-updated"));
    } else {
      toast.error(res.message || "Failed to cancel leave");
    }
  };
 
  const getStatusBadge = (status) => {
    if (status === 1)
      return (
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-[10px] font-black uppercase tracking-widest">
          <CheckCircle2 className="w-3 h-3" />
          Approved
        </div>
      );
 
    if (status === 0)
      return (
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-red-500/10 border border-red-500/20 text-red-400 text-[10px] font-black uppercase tracking-widest">
          <XCircle className="w-3 h-3" />
          Cancelled
        </div>
      );
 
    return (

      
      <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-yellow-500/10 border border-yellow-500/20 text-yellow-400 text-[10px] font-black uppercase tracking-widest">
        <Clock className="w-3 h-3" />
        Pending
      </div>

        
    );
  };
 
  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };
 
  return (
//     <div className="max-w-8xl mx-auto md:mt-20 mb-20 p-1">

// <div className="
//         relative overflow-hidden
//         rounded-[32px]  p-4 md:p-10
        // bg-gradient-to-br from-[#1e174a] to-[#0f0c29]
        // backdrop-blur-2xl text-white
        // border border-white/10
        // shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
//       ">


    
<div className="max-w-7xl mx-auto md:mt-20 mb-20">
<div className="
  relative
  overflow-hidden
  rounded-[30px]
  p-8
  bg-[#12082F]
  backdrop-blur-2xl text-white
  border border-white/10
  shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
">


      {/* HEADER SECTION */}
      <div className="flex items-center gap-4 mb-10">
        <div className="p-3.5 rounded-2xl bg-gradient-to-br from-purple-500 to-indigo-600 shadow-lg shadow-purple-500/20">
          <CalendarDays className="w-8 h-8 text-white" />
        </div>
        <div>
          {/* <h1 className="text-3xl font-black tracking-tight text-white">My Leave Diary</h1> */}
          <h1 className="text-3xl font-semibold text-white">
          My Leaves
        </h1>
          <p className="text-white/60 text-sm">Monitor your allowances and past applications</p>
        </div>
      </div>
 
      {/* BALANCE DASHBOARD */}
      <div className="mb-12">
        <div className="flex items-center gap-2 mb-4 ml-1">
          <PieChart className="w-4 h-4 text-blue-400" />
          <span className="text-[11px] font-black uppercase tracking-[1px] text-white/60">Available Allowances</span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 lg:grid-cols-5 gap-4 ">
          {balances
            .filter((b) =>
              ["Casual", "Short Leave", "", "Work From Home", "Marriage"].includes(b.leave_type)
            )
            .map((balance) => (
              <div
                key={balance.leave_type_id}
                className="
                  group relative overflow-hidden md:p-6 p-3 rounded-3xl
                  bg-white/5 border border-white/10 backdrop-blur-xl
                  transition-all duration-500 hover:-translate-y-1 hover:bg-white/[0.08]
                "
              >
                {/* <div className="absolute top-0 right-0 p-2 opacity-10 group-hover:opacity-20 transition-all">
                  <LayoutGrid className="w-12 h-12 text-white" />
                </div> */}
                <p className="text-[11px] font-semibold uppercase whitespace-nowrap text-white/60 mb-2">
                  {balance.leave_type}
                </p>
                <div className="flex items-baseline gap-1">
                  <span className="text-2xl font-black text-white">{balance.remaining_days ?? 0}</span>
                  <span className="text-[10px] font-bold text-white/40 uppercase">Left</span>
                </div>
                <div className="mt-4 md:pt-4 border-t border-white/5 flex gap-2 justify-between items-center">
                  <span className="text-[9px] font-bold text-white/30 uppercase tracking-tighter">Usage</span>
                  <span className="text-[10px] whitespace-nowrap font-semibold  text-blue-400 bg-blue-400/10 px-2 py-0.5 rounded-full">
                    {balance.used_days} Used
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>
 
      {/* LEAVE HISTORY LIST */}
      <div id="leave-list-section" className="space-y-6">
        <div className="flex items-center justify-between mb-4 px-1">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-purple-400" />
            <span className="text-[11px] font-black uppercase tracking-[1px] text-white/60">Application History</span>
          </div>
          <span className="text-[10px] font-bold text-white/20 uppercase">{filteredLeaves.length} Applications</span>
        </div>
 
        {filteredLeaves.length === 0 ? (
          <div className="flex flex-col items-center justify-center p-20 rounded-[40px] bg-white/5 border border-white/10 border-dashed">
            <AlertCircle className="w-12 h-12 text-white/10 mb-4" />
            <p className="text-white/30 font-bold uppercase tracking-widest text-sm whitespace-nowrap">No leave records found</p>
          </div>
        ) : (
          // <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-4">
            {filteredLeaves.map((leave) => (
              <div
                key={leave.id}
                className="
                  group relative overflow-hidden rounded-[32px] p-6 lg:p-8
                  bg-gradient-to-br from-[#1e174a]/60 to-[#0f0c29]/80
                  backdrop-blur-2xl border border-white/10
                  transition-all duration-300 hover:shadow-[0_20px_50px_-10px_rgba(0,0,0,0.5)] hover:border-white/20
                "
              >
                <div className="relative z-10">
                  {/* <div className="flex justify-between items-start mb-6">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <h3 className="text-lg font-black text-white">{leave.leave_type}</h3>
                        {leave.duration === 0.5 && (
                          <span className="text-[9px] font-black bg-blue-500/20 text-blue-400 px-2 py-0.5 rounded-full uppercase">Half</span>
                        )}
                      </div>
                      <p className="text-[10px] font-bold text-white/30 uppercase tracking-[1px]">ID #LV-{leave.id.toString().padStart(4, '0')}</p>
                    </div>
                    {getStatusBadge(leave.approval_status)}
                  </div> */}


<div className="flex justify-between items-start mb-1">
  <div>
    <div className="flex items-center gap-2 ">
      {/* <h3 className=" font-semibold text-white">{leave.leave_type}</h3> */}
       <h3 className="font-semibold">
         {leave.leave_type === "Unpaid Leave" ? "Leave Without Pay [LWP]" : leave.leave_type}
       </h3>
      {leave.duration === 0.5 && (
        <span className="text-[9px] font-black bg-blue-500/20 text-blue-400 px-2 py-0.5 rounded-full uppercase">
          Half
        </span>
      )}
    </div>

  
  </div>

  {/* RIGHT SIDE (STATUS + WITHDRAW) */}
  <div className="flex flex-row items-end gap-2">
    {getStatusBadge(leave.approval_status)}

    {/* ✅ SHOW ONLY IF PENDING */}
    {leave.approval_status === null && (
      <button
        onClick={() => setModal({ show: true, leaveId: leave.id })}
        className="
          flex items-center gap-1.5 px-3 py-1.5 rounded-lg
          bg-red-500/10 border border-red-500/20 text-red-400
          hover:bg-red-600 hover:text-white
          transition-all duration-300
          text-[10px] font-bold uppercase
        "
      >
        <Undo2 className="w-3 h-3" />
        Withdraw
      </button>
    )}
  </div>
</div>
 
                  {/* <div className="grid grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                    <div className="space-y-1">
                      <span className="text-[10px]  text-white/70  tracking-widest">Start Date</span>
                      <p className="text-xs font-semibold text-white/80">{formatDate(leave.leave_start_date)}</p>
                    </div>
                    <div className="space-y-1">
                      <span className="text-[10px]  text-white/70  tracking-widest">End Date</span>
                      <p className="text-xs  text-white/80">{formatDate(leave.leave_end_date)}</p>
                    </div>
                    <div className="space-y-1 hidden lg:block">
                      <span className="text-[10px]  text-white/70  tracking-widest">Calculated</span>
                      <p className="text-xs  text-white/80">{leave.duration} Days</p>
                    </div>

                 
                  </div> */}




              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm text-white/70 mt-4">
                <p>
                  <span className="text-white/50">Start:</span>{" "}
                  {formatDate(leave.leave_start_date)}
                </p>

                <p>
                  <span className="text-white/50">End:</span>{" "}
                  {formatDate(leave.leave_end_date)}
                </p>

                <p>
                  <span className="text-white/50">Duration:</span>{" "}
                  {leave.duration} days
                </p>
              </div>

              {leave.employee_comment && (
                <div className="mt-4 pt-4 border-t border-white/5 flex gap-3 items-start">
                  <MessageSquare className="w-4 h-4 text-blue-400 mt-0.5 shrink-0" />
                  <div className="space-y-1">
                    <p className="text-[10px] font-black uppercase tracking-widest text-white/30">My Reason</p>
                    <p className="text-xs italic text-white/50 leading-relaxed">"{leave.employee_comment}"</p>
                  </div>
                </div>
              )}

              {leave.admin_comment && (
                <div className="mt-3 flex gap-3 items-start">
                  <MessageSquare className="w-4 h-4 text-purple-400 mt-0.5 shrink-0" />
                  <div className="space-y-1">
                    <p className="text-[10px] font-black uppercase tracking-widest text-white/30">Admin Response</p>
                    <p className="text-xs italic text-purple-200/80 leading-relaxed">"{leave.admin_comment}"</p>
                  </div>
                </div>
              )}

              {leave.remarks && (
                <div className="mt-3 flex gap-3 items-start">
                  <AlertCircle className="w-4 h-4 text-amber-400 mt-0.5 shrink-0" />
                  <div className="space-y-1">
                    <p className="text-[10px] font-black uppercase tracking-widest text-white/30">System Remarks</p>
                    <p className="text-xs italic text-amber-200/80 leading-relaxed">"{leave.remarks}"</p>
                  </div>
                </div>
              )}
 
                  {/* <div className="flex items-center justify-between pt-6 border-t border-white/5">
                 
 
                    {leave.approval_status === null && (
                      <button
                        onClick={() => setModal({ show: true, leaveId: leave.id })}
                        className="
                          flex items-center gap-1.5 px-4 py-1.5 rounded-xl
                          bg-red-500/10 border border-red-500/20 text-red-400
                          hover:bg-red-600 hover:text-white transition-all duration-300
                          text-[10px] font-black uppercase tracking-widest
                        "
                      >
                        <Undo2 className="w-3 h-3" />
                        Withdraw
                      </button>
                    )}
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
 
      <CancelModal
        show={modal.show}
        onConfirm={confirmCancel}
        onClose={() => setModal({ show: false, leaveId: null })}
      />
    </div>
    </div>



  );
}







// import { useEffect, useState } from "react";
// import { getMyLeavesApi, cancelLeaveApi } from "../../app/api";
// import { toast } from "react-toastify";

// function CancelModal({ show, onConfirm, onClose }) {
//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 flex justify-center items-center z-50">
//       <div className="bg-white p-6 rounded-xl shadow-xl w-[300px] text-center">
//         <h2 className="text-xl font-semibold text-gray-700 mb-3">
//           Cancel Leave?
//         </h2>

//         <p className="text-gray-500 mb-5">
//           Are you sure you want to cancel this leave?
//         </p>

//         <div className="flex justify-center gap-3">
//           <button
//             onClick={onClose}
//             className="px-5 py-2 rounded-lg bg-gray-300"
//           >
//             No
//           </button>

//           <button
//             onClick={onConfirm}
//             className="px-5 py-2 rounded-lg bg-red-600 text-white"
//           >
//             Yes, Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default function MyLeaves() {
//   const [balances, setBalances] = useState([]);
//   const [leaves, setLeaves] = useState([]);
//   const [modal, setModal] = useState({ show: false, leaveId: null });

//   useEffect(() => {
//     loadLeaves();
//   }, []);


//   const loadLeaves = async () => {
//     const res = await getMyLeavesApi();
  
//     if (res?.success) {
//       setLeaves(res.data?.leaves || []);
//       setBalances(res.data?.balances || []);
//     }
//   };

  





//   const confirmCancel = async () => {
//     const id = modal.leaveId;
//     setModal({ show: false, leaveId: null });

//     const res = await cancelLeaveApi(id);

//     if (res.success) {
//       toast.success("Leave cancelled successfully");
//       loadLeaves();
//     } else {
//       toast.error(res.message || "Failed to cancel leave");
//     }
//   };

//   const getStatusBadge = (status) => {
//     if (status === 1)
//       return (
//         <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300 text-xs">
//           Approved
//         </span>
//       );

//     if (status === 0)
//       return (
//         <span className="px-3 py-1 rounded-full bg-red-500/20 text-red-300 text-xs">
//           Cancelled
//         </span>
//       );

//     return (
//       <span className="px-3 py-1 rounded-full bg-yellow-500/20 text-yellow-300 text-xs">
//         Pending
//       </span>
//     );
//   };

//   const formatDate = (date) => date?.split("T")[0];

//   return (
//     <div
//       className="
//         rounded-2xl
//         p-6
//         md:mt-20
//         bg-gradient-to-br
//         from-[#2d1c6a]
//         via-[#24155a]
//         to-[#12082f]
//         text-white
//         border border-white/10
//         shadow-2xl shadow-[#12082F]/60
//       "
//     >
//       <h2 className="font-bold  text-2xl mb-6">My Leaves</h2>





// {/* Leave Balances */}
// {/* Leave Balances - Small Tabs */}
// <div className="flex grid grid-cols-2 md:grid-cols-4 gap-3 mb-6 md:px-10 ">
//   {balances
//     .filter((b) =>
//       [
//         "Casual",
//         "Short Leave",
//         "Half Day",
//         "Work From Home",
//         "Marriage",
//       ].includes(b.leave_type)
//     )
//     .map((balance) => (
//       <div
//         key={balance.leave_type_id}
//         className="
//        p-5 md:p-6 
//           rounded-xl
//           bg-white/10
//           border border-white/10
//           backdrop-blur-md
//           min-w-[150px]
//         "
//       >
//         <p className="text-sm text-white/80 font-semibold whitespace-nowrap">
//           {balance.leave_type}
//         </p>
// <div className="flex flex-row gap-4">
//         <p className="text-base font-semibold mt-1">
//           {balance.remaining_days ?? 0}
//           <span className="text-xs font-normal text-white/80">
//             {" "}Total
//           </span>
//         </p>

//         <p className="text-base font-semibold mt-1">
//         <span className="text-xs font-normal text-white/80">
//             {" "}Used:
//           </span>
//            {balance.used_days}
//         </p>
//       </div>
//       </div>
//     ))}
// </div>









//       {leaves.length === 0 ? (
//         <p className="opacity-60 text-center py-10">
//           No leave records found
//         </p>
//       ) : (
//         <div className="flex flex-col gap-4">
//           {leaves.map((leave) => (
//             <div
//               key={leave.id}
//               className="bg-white/10 rounded-xl p-5 border border-white/10 hover:bg-white/20 transition"
//             >
//               <div className="flex justify-between items-center mb-3">
//                 <h3 className="font-semibold">{leave.leave_type}</h3>

//                 <div className="flex items-center gap-3">
//                   {getStatusBadge(leave.approval_status)}

//                   {leave.approval_status === null && (
//                     <button
//                       onClick={() =>
//                         setModal({ show: true, leaveId: leave.id })
//                       }
//                       className="px-3 py-1 rounded-full bg-red-500/20 text-red-300 text-xs hover:bg-red-500/40"
//                     >
//                       Cancel
//                     </button>
//                   )}
//                 </div>
//               </div>

              // <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm text-white/70">
              //   <p>
              //     <span className="text-white/50">Start:</span>{" "}
              //     {formatDate(leave.leave_start_date)}
              //   </p>

              //   <p>
              //     <span className="text-white/50">End:</span>{" "}
              //     {formatDate(leave.leave_end_date)}
              //   </p>

              //   <p>
              //     <span className="text-white/50">Duration:</span>{" "}
              //     {leave.duration} days
              //   </p>
              // </div>
//             </div>
//           ))}
//         </div>
//       )}

//       <CancelModal
//         show={modal.show}
//         onConfirm={confirmCancel}
//         onClose={() => setModal({ show: false, leaveId: null })}
//       />
//     </div>
//   );
// }
